import {EXPRESS_SERVER} from "../env_config";

export function createLogoFileUrl(listingId, fileName) {
  return `${EXPRESS_SERVER}/listingLogos/${listingId}/${fileName}`
}
